import { render, staticRenderFns } from "./Entry.vue?vue&type=template&id=80815864&"
import script from "./Entry.vue?vue&type=script&lang=js&"
export * from "./Entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports